export default __webpack_public_path__ + "static/flato-plugin-1fbfde0ac0fa040f51957b613efa9408.png";